// Seeded randomness for bots and simulations: the same seed, the same war.

// mulberry32: a small, fast, well-mixed seeded generator — floats in [0, 1).
export function seededRng(seed) {
    let a = seed >>> 0
    return () => {
        a = (a + 0x6d2b79f5) >>> 0
        let t = a
        t = Math.imul(t ^ (t >>> 15), t | 1)
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
}

export const pick = (rng, arr) => arr[Math.floor(rng() * arr.length)]
export const shuffled = (rng, arr) => {
    const a = [...arr]
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

